<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <h6>{{ isEdit ? "編輯品牌" : "新增品牌" }}</h6>
          </div>
          <div class="card-body">
            <form @submit.prevent="handleSubmit">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="name" class="form-control-label"
                      >品牌名稱</label
                    >
                    <input
                      class="form-control"
                      type="text"
                      id="name"
                      v-model="form.name"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="name_en" class="form-control-label"
                      >英文名稱 (Name En)</label
                    >
                    <input
                      class="form-control"
                      type="text"
                      id="name_en"
                      v-model="form.name_en"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="slug" class="form-control-label"
                      >代稱 (Slug)</label
                    >
                    <input
                      class="form-control"
                      type="text"
                      id="slug"
                      v-model="form.slug"
                    />
                    <small class="form-text text-muted">若留空將自動生成</small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="headerTitle" class="form-control-label"
                      >Header Title (大字黑字)</label
                    >
                    <input
                      class="form-control"
                      type="text"
                      id="headerTitle"
                      v-model="form.header_title"
                      placeholder="例如: 高爾夫球潮服飾&用品"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="headerSubtitle" class="form-control-label"
                      >Header Subtitle (小字灰底)</label
                    >
                    <input
                      class="form-control"
                      type="text"
                      id="headerSubtitle"
                      v-model="form.header_subtitle"
                      placeholder="例如: Golf Gods"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="description" class="form-control-label"
                      >描述</label
                    >
                    <textarea
                      class="form-control"
                      id="description"
                      rows="3"
                      v-model="form.description"
                    ></textarea>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="logo" class="form-control-label">Logo</label>
                    <input
                      class="form-control"
                      type="file"
                      id="logo"
                      @change="handleFileUpload"
                      accept="image/*,.heic,.heif"
                    />
                    <div v-if="previewUrl" class="mt-2">
                      <img
                        :src="previewUrl"
                        class="img-thumbnail"
                        style="max-height: 100px"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="banner" class="form-control-label"
                      >Brand Banner</label
                    >
                    <input
                      class="form-control"
                      type="file"
                      id="banner"
                      @change="handleBannerUpload"
                      accept="image/*,.heic,.heif"
                    />
                    <div v-if="previewBannerUrl" class="mt-2">
                      <img
                        :src="previewBannerUrl"
                        class="img-thumbnail"
                        style="max-height: 150px"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-control-label">狀態</label>
                    <div class="form-check form-switch ps-0">
                      <input
                        class="form-check-input ms-auto"
                        type="checkbox"
                        id="isActive"
                        v-model="form.is_active"
                      />
                      <label
                        class="form-check-label text-body ms-3 text-truncate w-80 mb-0"
                        for="isActive"
                        >啟用</label
                      >
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-control-label">選單顯示</label>
                    <div class="form-check form-switch ps-0">
                      <input
                        class="form-check-input ms-auto"
                        type="checkbox"
                        id="showInMenu"
                        v-model="form.show_in_menu"
                      />
                      <label
                        class="form-check-label text-body ms-3 text-truncate w-80 mb-0"
                        for="showInMenu"
                        >在選單中顯示</label
                      >
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="menuOrder" class="form-control-label"
                      >選單排序</label
                    >
                    <input
                      class="form-control"
                      type="number"
                      id="menuOrder"
                      v-model="form.menu_order"
                      placeholder="數字越小越靠前"
                    />
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-4">
                <button
                  type="button"
                  class="btn btn-light me-2"
                  @click="$router.push('/brands')"
                >
                  取消
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="loading"
                >
                  {{ loading ? "儲存中..." : "儲存" }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import Swal from "sweetalert2";
import { useRoute, useRouter } from "vue-router";
import { ref, onMounted, computed } from "vue";

export default {
  name: "BrandForm",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const loading = ref(false);
    const form = ref({
      name: "",
      name_en: "",
      slug: "",
      description: "",

      show_in_menu: false,
      menu_order: 0,
      logo_url: "",
      banner_url: "",
      header_title: "",
      header_subtitle: "",
    });
    const previewUrl = ref(null);
    const previewBannerUrl = ref(null);

    const isEdit = computed(() => route.params.id !== undefined);

    const fetchBrand = async (id) => {
      try {
        const response = await request.get(`/api/admin/brands/${id}`);
        const data = response.data.data;
        form.value = {
          name: data.name,
          name_en: data.name_en || "",
          slug: data.slug,
          description: data.description,
          is_active: !!data.is_active,
          show_in_menu: !!data.show_in_menu,
          menu_order: data.menu_order || 0,
          header_title: data.header_title || "",
          header_subtitle: data.header_subtitle || "",
        };
        if (data.logo_url) {
          form.value.logo_url = data.logo_url;
          previewUrl.value = data.logo_url;
        }
        if (data.banner_url) {
          form.value.banner_url = data.banner_url;
          previewBannerUrl.value = data.banner_url;
        }
      } catch (error) {
        console.error("Failed to fetch brand", error);
        Swal.fire("錯誤", "載入失敗", "error");
      }
    };

    const handleFileUpload = async (event) => {
      const file = event.target.files[0];
      if (file) {
        try {
          const formData = new FormData();
          formData.append("file", file);
          const response = await request.post("/api/admin/upload", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          if (response.data.success) {
            form.value.logo_url = response.data.url;
            previewUrl.value = response.data.url;
          } else {
            Swal.fire("錯誤", "上傳失敗", "error");
          }
        } catch (error) {
          console.error("Upload failed", error);
          Swal.fire("錯誤", "上傳失敗", "error");
        }
      }
    };

    const handleBannerUpload = async (event) => {
      const file = event.target.files[0];
      if (file) {
        try {
          const formData = new FormData();
          formData.append("file", file);
          const response = await request.post("/api/admin/upload", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          if (response.data.success) {
            form.value.banner_url = response.data.url;
            previewBannerUrl.value = response.data.url;
          } else {
            Swal.fire("錯誤", "上傳失敗", "error");
          }
        } catch (error) {
          console.error("Upload failed", error);
          Swal.fire("錯誤", "上傳失敗", "error");
        }
      }
    };

    const handleSubmit = async () => {
      loading.value = true;
      try {
        const data = {
          name: form.value.name,
          name_en: form.value.name_en,
          slug: form.value.slug,
          description: form.value.description,
          is_active: form.value.is_active,
          show_in_menu: form.value.show_in_menu,
          menu_order: form.value.menu_order,
          logo_url: form.value.logo_url,
          banner_url: form.value.banner_url,
          header_title: form.value.header_title,
          header_subtitle: form.value.header_subtitle,
        };

        if (isEdit.value) {
          await request.put(`/api/admin/brands/${route.params.id}`, data);
        } else {
          await request.post("/api/admin/brands", data);
        }

        router.push("/brands");
      } catch (error) {
        console.error("Failed to save brand", error);
        Swal.fire("錯誤", error.response?.data?.message || "儲存失敗", "error");
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      if (isEdit.value) {
        fetchBrand(route.params.id);
      }
    });

    return {
      form,
      loading,
      isEdit,
      previewUrl,
      handleSubmit,
      handleFileUpload,
      handleBannerUpload,
      previewBannerUrl,
    };
  },
};
</script>
